export default __webpack_public_path__ + "b87a50fff33ed8d7b9a247bb027b37e2.twig";